<template>
  <div id="contact-details--form">
    <form @submit.prevent="submit">
      <BaseAlert
        v-if="apiError"
        :hg-value="true"
        hg-type="error"
        ref="api-error">
        <p>{{apiError.message}}</p>
        <ul>
          <li v-for="error in apiError.errors" :key="`apiError_${error.field}`">
            {{error.field}} - {{error.message}}
          </li>
        </ul>
      </BaseAlert>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-layout row wrap>
            <v-flex v-if="person.type !== 'CUSTOMER'" xs12>
              <p>Company Name</p>
              <TextInputCommon
                v-model="model.companyName"
                :disabled="apiLoading"
                display-name="Company Name"
                identifier="company-name"
                ref="company-name" />
            </v-flex>

            <v-flex xs12>
              <p>Email</p>
              <TextInputCommon
                v-model="model.primaryEmail"
                :disabled="apiLoading"
                :validations="{ ...inputValidations.email, email: true, required: true }"
                display-name="Email Address"
                identifier="email"
                ref="email" />
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6>
          <v-layout row wrap>
            <v-flex xs12>
              <p>Phone Number(s)</p>
              <TextInputCommon
                v-model="model.mobilePhone"
                :disabled="apiLoading"
                :validations="{ ...inputValidations.phone, min: 10 }"
                display-name="Mobile"
                identifier="mobile-phone"
                mask="###-###-####"
                ref="mobile-phone" />
            </v-flex>

            <v-flex xs12>
              <TextInputCommon
                v-model="model.homePhone"
                :disabled="apiLoading"
                :validations="{ ...inputValidations.phone, min: 10 }"
                display-name="Home"
                identifier="home-phone"
                mask="###-###-####"
                ref="home-phone" />
            </v-flex>

            <v-flex xs12>
              <TextInputCommon
                v-model="model.workPhone"
                :disabled="apiLoading"
                :validations="{ ...inputValidations.phone, min: 10 }"
                display-name="Work"
                identifier="work-phone"
                mask="###-###-####"
                ref="work-phone" />
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 text-xs-right>
          <ButtonCommon class="submit-button" :disabled="apiLoading" type="submit">
            Save
          </ButtonCommon>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
import { Components, Constants } from '@spectorasoftware/homegauge-vue';

import ButtonCommon from '@/components/common/ButtonCommon.vue';
import TextInputCommon from '@/components/common/TextInputCommon.vue';

const { BaseAlert } = Components;
const DEFAULT_MODEL = {
  companyName: '',
  homePhone: '',
  mobilePhone: '',
  primaryEmail: '',
  workPhone: '',
};

export default {
  $_veeValidate: {
    validator: 'contact-details-form',
  },
  components: {
    BaseAlert,
    ButtonCommon,
    TextInputCommon,
  },
  props: {
    person: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      apiError: undefined,
      apiLoading: false,
      inputValidations: Constants.InputValidations,
      model: DEFAULT_MODEL,
    };
  },
  methods: {
    hydrateModel() {
      this.model.companyName = this.person.companyName;
      this.model.homePhone = this.person.homePhone;
      this.model.mobilePhone = this.person.mobilePhone;
      this.model.primaryEmail = this.person.primaryEmail;
      this.model.workPhone = this.person.workPhone;
    },
    async submit() {
      this.apiLoading = true;
      this.apiError = false;
      try {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
          const person = await this.$store.dispatch('Person/patchPerson', {
            ...this.model,
            personId: this.person.personId,
          });
          await this.$store.commit('Auth/setPerson', person);
          this.$emit('saved');
        }
      } catch (err) {
        this.apiError = err;
      }
      this.apiLoading = false;
    },
  },
  mounted() {
    this.hydrateModel();
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0 5px;
}
</style>
